import { SModel } from "servisofts-model";
import Action from "./Action";
import Reducer from "./Reducer";

export default new SModel<Action, Reducer>({
    info: {
        component: "paqueteServicio"
    },
    Columns: {
        "key": { type: "text", pk: true },
        "key_servicio": { type: "text", },
        "key_paquete": { type: "text", },
        "fecha_on": { type: "timestamp", label: "Fecha de registro" },
        "key_usuario": { type: "text", fk: "usuario" },
        "estado": { type: "integer" },
    },
    Action,
    Reducer,
});